<template>
  <div class="IndexApp" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="banner">
      <swiper :options="swiperOption">
        <swiper-slide class="swiper-slide" v-for="(item,i) in setAdvert">
          <a><img :src="baseUrl+item.images"></a>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="nav">
      <a @click="$router.push('login')" v-if="isLogin == 0">
        <img src="~assets/images/m5.png"/>
        <p>Peer Review</p>
      </a>
      <a @click="$router.push('checkny')" v-if="isLogin == 1">
        <img src="~assets/images/m5.png"/>
        <p>Peer Review</p>
      </a>
      <a @click="$router.push('contact')">
        <img src="~assets/images/m4.png"/>
        <p>Contact Us</p>
      </a>
      <a @click="$router.push('comment')">
        <img src="~assets/images/m3.png"/>
        <p>Reviews</p>
      </a>
      <a @click="$router.push('lyan')">
        <img src="~assets/images/m2.png"/>
        <p>Message Board</p>
      </a>
    </div>
    <div class="commen">
      <h2>
        <div class="ctitle">Latest News<a @click="$router.push('news')">More<i class="el-icon-arrow-right"></i></a></div>
      </h2>
      <ul class="news">
        <li v-for="(item,i) in setNewsIndex">
          <a @click="$router.push('ndetail?id='+item.id)">
            <p class="showPic">
              <img :src="baseUrl+item.image" style="max-width: 100%;">
            </p> 
            <div class="lesson">
              <p class="camp">{{item.title}}</p>
              <p class="money">{{item.createtime}}</p>
            </div>
          </a>
        </li>
      </ul>
    </div>
    <div class="commen">
      <h2>
        <div class="ctitle">Academic Journals<a @click="$router.push('qkan')">More<i class="el-icon-arrow-right"></i></a></div>
      </h2>
      <ul class="qkan">
        <li @click="$router.push('qdetail?id='+item.id)" v-for="(item,i) in setQkanIndex">
          <div class="title">
            <img :src="baseUrl+item.image" >
            <div class="conTitle">
              <span>{{item.title}}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="commen">
      <h2>
        <div class="ctitle">Message Board<a @click="$router.push('lyan')">More<i class="el-icon-arrow-right"></i></a></div>
      </h2>
      <ul class="lyan">
        <div v-if="setLyanIndex.length <= 0" style="text-align:center;padding:60px 0">No messages yet~</div>
        <li v-for="(item,i) in setLyanIndex" v-if="setLyanIndex.length > 0">
          <div class="user">
            <span>{{item.username}}</span>
            <font>{{item.createtime}}</font>
          </div>
          <p>{{item.content}}</p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        swiperOption: {
          autoplay : {
            disableOnInteraction: false,
            delay: 5000
          },
          initialSlide: 0,
          speed: 1000,
          loop:true,
          grabCursor: true,
          autoHeight: true,   
          scrollbar: '.swiper-scrollbar',
          mousewheelControl: true,
          observeParents: true,
          pagination: {
            el: '.swiper-pagination',
            clickable :true, //点击分页器的指示点分页器会控制Swiper切换
          },     
        },
        setAdvert:[],
        setNewsIndex:[],
        setQkanIndex:[],
        setLyanIndex:[],
        isLogin:0
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      if(localStorage.getItem('qkan') == null){
        this.isLogin = 0
      }else{
        this.isLogin = 1
      }
    },
    mounted() {
      this.beforeMount();
      this.getAdvert();
      this.getNewsIndex();
      this.getQkanIndex();
      this.getLyanIndex()
    },
    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },

      getAdvert:function(){
        var that = this;
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/index/getAdvert',
          dataType:'json',
          success:function(data){
            that.setAdvert = data.data;
            that.fullscreenLoading = false;
          }
        })
      },
      getNewsIndex:function(){
        var that = this;
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/index/newsIndex',
          dataType:'json',
          success:function(data){
            that.setNewsIndex = data.data;
            that.fullscreenLoading = false;
          }
        })
      },
      getQkanIndex:function(){
        var that = this;
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/index/qkanIndex',
          dataType:'json',
          success:function(data){
            that.setQkanIndex = data.data;
            that.fullscreenLoading = false;
          }
        })
      },
      getLyanIndex:function(){
        var that = this;
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/index/lyanIndex',
          dataType:'json',
          success:function(data){
            that.setLyanIndex = data.data;
            that.fullscreenLoading = false;
          }
        })
      },
    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .IndexApp .el-message-box{
    width:30%
  }
  .IndexApp{
    max-width:750px;
    margin:0 auto;
  }
  .IndexApp .banner{
    background:#fff;
  }
  .IndexApp .banner img{
    display:block;
    width:100%
  }
  
  .IndexApp .nav{
    width:100%;
    background:#fff;
    padding-bottom:15px
  }
  .IndexApp .nav:after,.IndexApp .commen ul li:after{
    clear: both;
    content: '.';
    display: block;
    width: 0;
    height: 0;
    visibility: hidden;
  }
  .IndexApp .nav a{
    float:left;
    width:25%;
    margin-top:15px
  }
  .IndexApp .nav a img{
    width:40px;
    display:block;
    margin:0 auto
  }
  .IndexApp .nav a p{
    width:100%;
    text-align:center;
    font-size:14px;
    color:#333;
    padding-top:8px;
    font-weight:bold;
  }

  .IndexApp .commen{
    background:#fff;
    width:100%;
    margin-top:10px
  }
  .IndexApp .commen h2{
    margin:0 auto;
    font-size:16px;
    padding:15px 0;
    border-bottom:solid 1px #f5f5f5;
  }
  .IndexApp .commen h2 .ctitle{
    width:92%;
    margin:0 auto;
    position:relative;
    padding-left:2%;
  }
  .IndexApp .commen h2 .ctitle:after{
    content:'';
    width: 3px;
    height: 15px;
    background: #141EF1;
    position:absolute;
    left:0px;
    top:1px;
    border-radius: 3px;
  }
  .IndexApp .commen h2 a{
    float:right;
    font-size:14px;
    font-weight:normal;
    color:#666;
    margin-top:2px
  }
  .IndexApp .commen .news {
    width: 96%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 0 auto;
    padding-bottom:12px
  }
  .IndexApp .commen .news li{
    width:48.5%;
    background-color: #fff;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1);
    margin-top:12px;
    border-radius: 6px;
  }
  .IndexApp .commen .news li a{
    display:block;
    width:100%;
    text-decoration: none;
  }
  .IndexApp .commen .news li a img{
    border-radius: 6px 6px 0 0;
  }
  .IndexApp .commen .news li a .camp{
    width:92%;
    margin:0 auto;
    font-size:15px;
    font-weight: bold;
    color:#333333;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .IndexApp .commen .news li a .money{
    width:92%;
    margin:0 auto;
    font-size:14px;
    color:#666;
    padding:8px 0
  }

  .IndexApp .commen .qkan li{
    width:92%;
    margin:15px auto 0 auto;
    border-bottom:solid 1px #f5f5f5;
    padding-bottom:15px
  }
  .IndexApp .commen .qkan li .title{
    position:relative;
    width:100%;
  }
  .IndexApp .commen .qkan li .title img{
    float:left;
    width:30%;
    border-radius:6px;
    object-fit: cover;
    height:130px
  }
  .IndexApp .commen .qkan li .title .conTitle{
    float:left;
    width:67%;
    margin-left:3%;
    height:130px;
    position: relative;
  }
  .IndexApp .commen .qkan li .title .conTitle span{
    display:block;
    color:#333333;
    width:100%;
    overflow: hidden;
    font-size:15px;
    font-weight: bold;
    line-height:26px;
    position: absolute;
    top:50%;
    transform: translateY(-50%);
  }

  .IndexApp .commen .lyan{
    width: 92%;
    margin: 0 auto;
  }
  .IndexApp .commen .lyan li{
    width:100%;
    margin:15px auto 0 auto;
    border-bottom:solid 1px #f5f5f5;
    padding-bottom:15px
  }
  .IndexApp .commen .lyan li .user span{
    font-weight:bold;
    font-size:16px;
    color:#000
  }
  .IndexApp .commen .lyan li .user font{
    float:right;
    font-size:14px;
    color:#666
  }
  .IndexApp .commen .lyan li p{
    font-size:15px;
    color:#333;
    padding-top:8px;
    line-height:22px
  }
</style>